import type { Component } from 'vue';
import V2ClubWhatsNewModal from '@/components/modals/whats-new/V2ClubWhatsNewModal.vue';
import {
  evaluateClubWhatsNew,
  IClubWhatsNewInput,
  IWhatsNewEvaluation,
} from './club-whats-new-eligibility';
import { CLUB_LAUNCH_ID, TWhatsNewId } from './whats-new.const';

/**
 * Announcement registry: the host (use-whats-new.ts) walks it and shows the
 * first eligible entry. A future announcement is a new id in WHATS_NEW_IDS
 * (API first!), an evaluate function, a modal, and one row here — the host
 * stays unchanged.
 */
export interface IWhatsNewEntry {
  id: TWhatsNewId;
  evaluate: (input: IClubWhatsNewInput) => IWhatsNewEvaluation;
  modal: Component;
}

export const WHATS_NEW_REGISTRY: IWhatsNewEntry[] = [
  {
    id: CLUB_LAUNCH_ID,
    evaluate: evaluateClubWhatsNew,
    modal: V2ClubWhatsNewModal,
  },
];
